var _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
function SvgRtvLogo(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 20"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M24 20h-4.2l-5.7-8.2H8.2L5.8 8.4h12C19 8.4 20 7.3 20 5.9c0-1.3-1-2.4-2.2-2.4H2.4L0 0h17.2c1.9 0 3.5.6 4.7 1.9 1.1 1.1 1.6 2.4 1.6 4 0 1.3-.5 2.5-1.4 3.5-.9 1-2.2 1.7-3.8 2.1L24 20z"
  })));
}
export default SvgRtvLogo;